(function () {
    'use strict';

    angular.module("imApp").factory("selectTextileModelService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1516,
                    parameters: parms || {}
                });
            },
            listTextileModels: function (parms) {
                return $ihttp.post({
                    method: 1517,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
